export class LenderModel {
  constructor(
    public LEGAL_NAME: string,
    public EMAIL: string) {
  }
}
